
import React, { useState, useEffect } from 'react'
import Swiper from 'swiper'

export default function Rol3d(props) {
  const [ifon, setIfon] = useState({
    rol3d: null
  })

  useEffect(() => {
    const example = new Swiper('.Rol3d', {
      loop: true,
      autoplay: true,
      slidesPerView: 'auto',
      effect: 'coverflow',
      speed: props.playbackSpeed,
      centeredSlides: true
    })

    setIfon({
      ...ifon,
      rol3d: example
    })
    window.example = example

    /* example.params.speed  修改播放速度 */

    return () => {
      example.destroy && example.destroy()
    }
  }, [])

  useEffect(() => {
    ifon.rol3d && (ifon.rol3d.params.speed = props.playbackSpeed)
  }, [props.playbackSpeed])

  return (<div className='Rol3d'>
    <div class='swiper-wrapper'>
      {props.ifon.image_id_list.map((item) => {
        return <div class='swiper-slide' key={item.id}>
          <img className='slide_img' src={item.src}></img>
        </div>
      })}

    </div>
  </div>)
}
console.log(React)
